<template>
  <div class="NovaSimulacao">
    <br />
    <!-- propriedades do feixe -->

    <div class="row">
      <div class="col m8 s12">
        <div class="card">
          <div class="card-content">
            <h4>Nova Simulação</h4>
            <p>
              Primeiro defina o
              <b>tipo</b> de feixe, a
              <b>propriedade</b> que quer visualizar e o
              <b>comprimento de onda</b>
            </p>
          </div>
          <div class="card-tabs">
            <ul class="tabs tabs-fixed-width tabsNovaSimulacao">
              <li class="tab">
                <a class="active" href="#PropriedadesDoFeixe">Propriedades do Feixe</a>
              </li>
              <li class="tab disabled">
                <a href="#PropriedadesDaParticula">Propriedades da Partícula</a>
              </li>
              <li class="tab disabled">
                <a href="#TipoFormatoGrafico">Formato de Visualização</a>
              </li>
            </ul>
          </div>
          <div class="card-content formSimulacao">
            <div id="PropriedadesDoFeixe">
              <propriedadesFeixe @select_tipo_feixe="alterar_tipo_feixe" />

              <feixeBessel
                v-if="tipo_feixe === 'bessel'"
                @DefineAnguloDeAxicon="atualizaAnguloDeAxicon"
              />

              <feixeGauss v-if="tipo_feixe === 'gauss'" />
              <frozenWave v-if="tipo_feixe === 'frozen'" />
              <outros v-if="tipo_feixe === 'outros'" />
              <exponencial v-if="tipo_feixe === 'exponencial'" />
            </div>
            <div id="PropriedadesDaParticula">
              <propriedadesParticula />
            </div>
            <div id="TipoFormatoGrafico">
              <tipoGrafico />
              <formatoSaida />
            </div>
          </div>

          <div class="card-action right-align">
            <a
              class="white-text btn btn-large"
              id="BtnRodarSimulacao"
              target="_blank"
              @click="RodarSimulacao"
            >
              Iniciar Simulação
              <i class="material-icons right">send</i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="progress">
      <div class="indeterminate"></div>
    </div>
  </div>
</template>
<script>
import propriedadesFeixe from "@/components/novaSimulacao/propriedadesFeixe.vue";
import feixeBessel from "@/components/novaSimulacao/feixeBessel.vue";
import feixeGauss from "@/components/novaSimulacao/feixeGauss.vue";
import propriedadesParticula from "@/components/novaSimulacao/propriedadesParticula.vue";
import frozenWave from "@/components/novaSimulacao/frozenWave.vue";
import tipoGrafico from "@/components/novaSimulacao/tipoGrafico.vue";
import formatoSaida from "@/components/novaSimulacao/formatoSaida.vue";
import exponencial from "@/components/novaSimulacao/exponencial.vue";
import outros from "@/components/novaSimulacao/outros.vue";
import firebase from "firebase";
import axios from "axios";
import M from "materialize-css";
import $ from "jquery";

export default {
  name: "TabNovaSimulacao",

  components: {
    propriedadesFeixe,
    propriedadesParticula,
    feixeBessel,
    feixeGauss,
    frozenWave,
    tipoGrafico,
    formatoSaida,
    exponencial,
    outros
  },

  mounted() {
    M.FormSelect.init(document.querySelectorAll("select"));
    this.NotificarPushUsuario('Bem vindo!!!', 'Te enviaremos notificações sobre as simulações e tudo mais!!!');
  },

  data() {
    return {
      propriedade_feixe: "",
      comprimento_onda: 1024e-9,
      tipo_feixe: "",
      instance: "",
      title: "Intensidade do Campo Elétrico",
      axicon: Math.PI / 180,
      // urlBase: "http://localhost:3000/exec/200/",
      urlBase: "http://ic.itp.ifsp.edu.br/glmt/exec/200/",
      urlPythonApi: "",
      imgSimulation: "",
      loading: false,
      info: null,
      errored: false
    };
  },
  methods: {
    alterar_tipo_feixe: function(cont) {
      let data = cont.dados;
      this.tipo_feixe = data.tipo_feixe;
      this.comprimento_onda = data.comprimento_onda;
      this.propriedade_feixe = data.propriedade_feixe;
      this.title = data.title;
      this.urlPythonApi =
        this.urlBase +
        "'" +
        this.title +
        "'/" +
        this.comprimento_onda +
        "/" +
        this.axicon;
    },
    nova_simulacao: function() {},

    atualizaAnguloDeAxicon: function(dados) {
      this.axicon = dados.axicon;
    },
    setImgSimulation: function(_imgSimulation) {
      this.imgSimulation = _imgSimulation;
    },
    NotificarPushUsuario: function(title, message) {
      var options = {
        icon: "/img/icons/android-icon-192x192.png",
        body: message
      };

      if ("Notification" in window) {
        Notification.requestPermission();
        if ("showNotification" in ServiceWorkerRegistration.prototype) {
          navigator.serviceWorker.ready.then(function(registration) {
            registration.showNotification(title, options);
          });
        } else {
          new Notification(title, options);
        }
      }
    },
    RodarSimulacao: async function() {
      //VALIDAÇÃO ====================
      if (this.tipo_feixe != "bessel") {
        M.toast({
          html:
            "Infelizmente não estamos preparados para realizar esta simulação ainda, altere o tipo de feixe",
          classes: "rounded"
        });
        return false;
      }

      //endereço API ==================
      this.urlPythonApi =
        this.urlBase +
        "'" +
        this.title +
        "'/" +
        this.comprimento_onda +
        "/" +
        this.axicon;

      //DESABILITAR E ALERTAR USUÁRIO DO PROCESSAMENTO =====================
      $(".formSimulacao").addClass("disabledDuringSimulation");
      $("#BtnRodarSimulacao").addClass("disabled");
      M.toast({
        html:
          "Sua simulação começou, assim que tudo estiver pronto te avisamos!",
        classes: "rounded blue"
      });
      var imgSimulationLocalVar = "";

      //PROCESSAMENTO E GET DA IMAGEM DO GRÁFICO ==================
      this.loading = true;

      await axios
        .get(this.urlPythonApi)
        .then(response => {
          imgSimulationLocalVar = response.data.data_img;
        })
        .catch(error => {
          M.toast({
            html: "Um erro aconteceu durante a sua simulação! " + error,
            classes: "rounded red darken-4"
          });
          this.loading = false;
          this.errored = true;
        })
        .finally(() => {
          if (this.errored) return false;
          M.toast({
            html: "A execução da sua simulação foi encerrada!",
            classes: "rounded green darken-4"
          });
          this.loading = false;
        });
      if (this.errored) {
        $(".formSimulacao").removeClass("disabledDuringSimulation");
        $("#BtnRodarSimulacao").removeClass("disabled");
        this.NotificarPushUsuario(
          "Um erro aconteceu na sua simulação",
          "Infelizmente ela foi cancelada devido a esse erro, já estamos verificando o que pode ter acontecido"
        );
        return false;
      }
      $(".formSimulacao").removeClass("disabledDuringSimulation");
      $("#BtnRodarSimulacao").removeClass("disabled");
      this.imgSimulation = imgSimulationLocalVar;

      //AJUSTE DAS INFORMAÇÕES ====================
      var simulation = {
        title: this.title,
        axicle_angle: this.axicon,
        comprimento_de_onda: this.comprimento_onda,
        data: Date(),
        tipo_feixe: this.tipo_feixe,
        url_simulacao: this.urlPythonApi,
        propriedade_feixe: this.propriedade_feixe,
        imgSimulation: this.imgSimulation
      };

      //ARMAZENAMENTO NO BANCO DE DADOS ====================
      firebase
        .database()
        .ref("users/" + firebase.auth().currentUser.uid)
        .child("simulations")
        .push(simulation);
      
      this.NotificarPushUsuario(
        "Sua simulação foi concluída!!",
        'Parabéns, sua simulação já está disponível nas aba "Minhas Simulações"'
      );
    }
  }
};
</script>